import { TrackingApi } from 'api/TrackingApi';
import { getScreenOrientationWithSizes } from 'helpers/device';

export const usePromoteVipPopupAnalytics = () => {
  const DEFAULT_EVENT_NAME = 'vip_full_price';
  const DISCOUNT_EVENT_NAME = 'vip_discount_price';

  const trackPromoteVipPopupShow = (payload: { isDiscount: boolean }) => {
    TrackingApi.trackPopup({
      info: payload.isDiscount ? DISCOUNT_EVENT_NAME : DEFAULT_EVENT_NAME,
      operation: 'show',
      screen: getScreenOrientationWithSizes(),
    }).catch();
  };

  const trackPromoteVipPopupClick = (payload: {
    isDiscount: boolean;
    orderId?: string;
  }) => {
    TrackingApi.trackPopup({
      info: payload.isDiscount ? DISCOUNT_EVENT_NAME : DEFAULT_EVENT_NAME,
      operation: 'click',
      parameter: payload?.orderId,
      screen: getScreenOrientationWithSizes(),
    }).catch();
  };

  const trackPromoteVipPopupClose = (payload: { isDiscount: boolean }) => {
    TrackingApi.trackPopup({
      info: payload.isDiscount ? DISCOUNT_EVENT_NAME : DEFAULT_EVENT_NAME,
      operation: 'close',
      screen: getScreenOrientationWithSizes(),
    }).catch();
  };

  return {
    trackPromoteVipPopupShow,
    trackPromoteVipPopupClick,
    trackPromoteVipPopupClose,
  };
};
